import * as React from 'react';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { SectionHeader } from 'app/components/section-header/section-header';
import { MainLanguage } from './main-language/main-language';
import { getTextInLanguage } from './translations/get-text-in-language';
import { getLanguageValidation } from './translations/get-language-validation';
import { TranslationsToggle } from './translations/translations-toggle';
import { TranslationRow } from './translations/translation-row';
import { TranslationsProps } from './types';
import styles from './translations.scss';

export class TranslationsComponent extends React.Component<TranslationsProps> {

  public render() {
    const {
      primaryText, secondaryText, primaryTextValueKey, secondaryTextValueKey,
      primaryTextMaxLength, secondaryTextMaxLength, languageOptions, mainLanguage,
      secondaryTextMode, readOnly, validation, validationLongDescription,
      onPrimaryTextChange, onSecondaryTextChange,
      copyPrimaryTextToAllTranslations, copySecondaryTextToAllTranslations,
      hasTranslationsToggled, switchTranslationsToggle,
      primaryTextLabel, secondaryTextLabel, secondaryTextInfo,
      copyPrimaryTextToAllLabel, copySecondaryTextToAllLabel,
      translationsHeaderLabel, switchTranslationsToggleLabel
    } = this.props;

    const mainPrimaryTextValue = getTextInLanguage(primaryText, mainLanguage);
    const mainSecondaryTextValue = getTextInLanguage(secondaryText, mainLanguage);

    const mainPrimaryTextValidation = getLanguageValidation(validation, mainLanguage, primaryTextValueKey);
    const mainSecondaryTextValidation = getLanguageValidation(validationLongDescription, mainLanguage, secondaryTextValueKey);

    const additionalTranslations = languageOptions?.filter(language => language.value !== mainLanguage) || [];

    return <>
      <MainGridContainer>
        <MainLanguage
          primaryText={mainPrimaryTextValue?.description}
          secondaryText={mainSecondaryTextValue?.description}
          primaryTextMaxLength={primaryTextMaxLength}
          secondaryTextMaxLength={secondaryTextMaxLength}
          mainLanguage={mainLanguage}
          secondaryTextMode={secondaryTextMode}
          readOnly={readOnly}
          displayCopyToAll={additionalTranslations.length > 0}
          onPrimaryTextChange={onPrimaryTextChange}
          onSecondaryTextChange={onSecondaryTextChange}
          copyPrimaryTextToAllTranslations={copyPrimaryTextToAllTranslations}
          copySecondaryTextToAllTranslations={copySecondaryTextToAllTranslations}
          primaryTextValidation={mainPrimaryTextValidation}
          secondaryTextValidation={mainSecondaryTextValidation}
          primaryTextLabel={primaryTextLabel}
          secondaryTextLabel={secondaryTextLabel}
          secondaryTextInfo={secondaryTextInfo}
          copyPrimaryTextToAllLabel={copyPrimaryTextToAllLabel}
          copySecondaryTextToAllLabel={copySecondaryTextToAllLabel} />
      </MainGridContainer>
      {additionalTranslations.length > 0 && <MainGridContainer>
        <SectionHeader>
          <div className={styles.sectionHeaderContainer}>
            {translationsHeaderLabel}
            <TranslationsToggle
              isToggled={hasTranslationsToggled}
              onChange={switchTranslationsToggle}
              switchTranslationsToggleLabel={switchTranslationsToggleLabel} />
          </div>
        </SectionHeader>
        {!!hasTranslationsToggled && additionalTranslations.map(language => {
          const primaryTextValue = getTextInLanguage(primaryText, language.value);
          const secondaryTextValue = getTextInLanguage(secondaryText, language.value);

          const primaryTextValidation = getLanguageValidation(validation, language.value, primaryTextValueKey);
          const secondaryTextValidation = getLanguageValidation(validationLongDescription, language.value, secondaryTextValueKey);

          return <TranslationRow
            key={language.value}
            language={language}
            primaryText={primaryTextValue?.description}
            secondaryText={secondaryTextValue?.description}
            primaryTextMaxLength={primaryTextMaxLength}
            secondaryTextMaxLength={secondaryTextMaxLength}
            secondaryTextMode={secondaryTextMode}
            readOnly={readOnly}
            onPrimaryTextChange={onPrimaryTextChange}
            onSecondaryTextChange={onSecondaryTextChange}
            primaryTextValidation={primaryTextValidation}
            secondaryTextValidation={secondaryTextValidation}
            primaryTextLabel={primaryTextLabel}
            secondaryTextInfo={secondaryTextInfo}
            secondaryTextLabel={secondaryTextLabel} />;
        })}
      </MainGridContainer>}
    </>;
  }
}
